import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import DealerRequestKits from "../components/simLocked/dealer/request/dealerRequestKits";
import DealerKitInventory from "../components/simLocked/dealer/inventory/dealerKitInventory";
import AssignKitToDealer from "../components/simLocked/dealer/assign/assignKitToDealer";
import AssignKitDetail from "../components/simLocked/dealer/assign/assignKitDetail";
import AssignedKitList from "../components/simLocked/dealer/assign/assignedKitList";

export const simLockedRoutes = [
	<Route
		key="simlocked-dealer-new-request"
		path={_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DealerRequestKits} />}
	/>,
	<Route
		key="simlocked-dealer-inventory"
		path={_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.Inventory}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DealerKitInventory} />}
	/>,
	<Route
		key="simlocked-dealer-assign-kit"
		path={_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={AssignKitToDealer} />}
	/>,
	<Route
		key="simlocked-dealer-assign-kit-detail"
		path={_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKitDetail}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={AssignKitDetail} />}
	/>,
	<Route
		key="simlocked-dealer-assigned-kit-list"
		path={_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignedKitList}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={AssignedKitList} />}
	/>,
];
